import React from 'react';
import useCurrentTextStyle from '@src/hooks/useCurrentTextStyle';

export const ArticleAuthor = ({ article, settings, }) => {
  const { getCurrentTextStyle } = useCurrentTextStyle();

  const {
    colour_scheme,
    classes,
    author_style,
    author_style_mobile,
    author_style_tablet,
    author_style_ultrawide,
    author_style_enable_responsive,
    author_alignment = 'left',
    padding_top = 0,
    padding_right = 0,
    padding_bottom = 0,
    padding_left = 0,
    margin_top = 0,
    margin_right = 0,
    margin_bottom = 0,
    margin_left = 0
  } = settings;

  // Do somehthing for description instead of excerpt
  if (!article?.author) return null;

  return (
    <div 
      className={`
        w-full
        color-${colour_scheme}
        text-${author_alignment}
        pt-[${padding_top}px]
        pb-[${padding_bottom}px]
        pl-[${padding_left}px]
        pr-[${padding_right}px]
        mt-[${margin_top}px]
        mb-[${margin_bottom}px]
        ml-[${margin_left}px]
        mr-[${margin_right}px]
        ${classes}
      `}
    >
      <p className={getCurrentTextStyle(author_style, author_style_enable_responsive, author_style_mobile, author_style_tablet, author_style_ultrawide) || 'b1'}>{article?.author}</p>
    </div>
  );
};